import "./ShowNavigationBtn.css"

export default function ShowNavigationBtn({showNavigation, setShowNavigation}) {
    const showNavigationHandler = (e) => {
        e.stopPropagation()
        setShowNavigation(prevShowNavigation => !prevShowNavigation)
    }

    return (
        <button
            className={`show-navigation-btn ${showNavigation ? 'active' : ''}`}
            onClick={showNavigationHandler}
        >
            <div className="burger-icon">
                <div className="burger-line"></div>
                <div className="burger-line"></div>
                <div className="burger-line"></div>
            </div>
        </button>
    )
}